import React from 'react';
import moment from 'moment';
import { Grid, Typography } from '@mui/material';
import { dateFormate } from 'utils/utils';
import pickup from 'assets/images/pickUp.svg';
import drop from 'assets/images/drop.svg';

function PickUp(props) {
  const tableData = props?.tableData;
  const waypoints = tableData?.additionalInfo?.waypoints || [];
  const containerRef = React.useRef(null);

  // Calculate and update heights dynamically
  React.useEffect(() => {
    const updateHeights = () => {
      if (containerRef.current) {
        const pickupElement = containerRef.current.querySelector('.pickupSection');
        const waypointElements = containerRef.current.querySelectorAll('.waypointSection');
        const dropElement = containerRef.current.querySelector('.dropSection');

        if (pickupElement && dropElement) {
          let totalHeight = 0;
          
          // Calculate waypoints total height
          waypointElements.forEach(element => {
            totalHeight += element.offsetHeight;
          });
          
          // Calculate drop section offset from pickup
          const pickupRect = pickupElement.getBoundingClientRect();
          const dropRect = dropElement.getBoundingClientRect();
          const pickupIcon = pickupElement.querySelector('.pickUpPosition');
          const dropIcon = dropElement.querySelector('.dropImg img');
          
          if (pickupIcon && dropIcon) {
            const pickupIconRect = pickupIcon.getBoundingClientRect();
            const dropIconRect = dropIcon.getBoundingClientRect();
            
            // Calculate the distance between icons
            const distance = dropIconRect.top - pickupIconRect.bottom;
            totalHeight = Math.max(distance, 20); // Minimum 20px line
          } else {
            // Fallback calculation when no waypoints
            totalHeight = waypoints.length > 0 ? totalHeight + dropElement.offsetHeight : dropElement.offsetTop - pickupElement.offsetTop - 20;
          }

          // Update CSS custom property for dotted line height
          pickupElement.style.setProperty('--total-sections-height', `${totalHeight}px`);
        }
      }
    };

    // Use setTimeout to ensure DOM is fully rendered
    setTimeout(updateHeights, 100);

    // Recalculate on window resize
    window.addEventListener('resize', updateHeights);
    
    // Cleanup
    return () => window.removeEventListener('resize', updateHeights);
  }, [waypoints.length, tableData]);

  return (
    <div className="heightPickUp" ref={containerRef}>
      
      {/* PickUp Section */}
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className='pickupSection'
      >
        <Grid item xs={1} className='pickUpItem'>
          <div className='pickUpImg'></div>
          <div className='pickImg'><img src={pickup} alt="pickup" className='pickUpPosition' /></div>
        </Grid>
        <Grid item xs={11}>
          <div className='content-wrapper'>
            <Typography className="font14 fontSemi colorGrey">Pick Up</Typography>
            <Typography className="font14 fontNormal">
              {tableData?.sourceAddress}
            </Typography>
            <Typography className="font12 fontNormal colorGrey">
              {moment((tableData?.pickUpTime && tableData?.pickUpTime !== null) ? tableData?.pickUpTime : tableData?.scheduledTime).format('DD MMM YYYY, hh:mm a')}
            </Typography>
            <Typography className="font12 fontNormal colorBlue">
              {tableData?.distance ? tableData?.distance + "km" : ''}
            </Typography>
          </div>
        </Grid>
      </Grid>

      {/* Waypoints/Stops Section */}
      {waypoints.map((waypoint, index) => (
        <Grid
          key={index}
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          className='waypointSection'
        >
          <Grid item xs={1} className='waypointItem'>
            <div className='waypointImg'></div>
            <img src={drop} alt="waypoint" className='waypointPosition' />
          </Grid>
          <Grid item xs={11}>
            <div className='content-wrapper'>
              <Typography className="font14 fontSemi colorGrey">
                Stop {index + 1}
              </Typography>
              <Typography className="font14 fontNormal">
                {waypoint.address}
              </Typography>
            </div>
          </Grid>
        </Grid>
      ))}

      {/* Drop Section */}
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className='dropSection'
      >
        <Grid item xs={1} className='dropItem'>
          <div className='dropImg'>
            <img src={drop} alt="drop" /> 
          </div>
        </Grid>
        <Grid item xs={11}>
          <div className='content-wrapper'>
            <Typography className="font14 fontSemi colorGrey">
              {(tableData?.status?.toLowerCase() === 'completed' || tableData?.status?.toLowerCase() === 'cancelled') ? 'Dropped' : 'Dropping'}
            </Typography>
            <Typography className="font14 fontNormal">
              {tableData?.destinationAddress}
            </Typography>
            <Typography className="font12 fontNormal colorGrey">
              {tableData?.completedAt ? (dateFormate(tableData?.completedAt, 'DD MMM YYYY, hh:mm a')) : ''}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default PickUp;
